/**
 * MIRROR — generated by scripts/sync-rental-terms.js. Do not edit by hand.
 *
 * The admin panel is a separate CRA app and cannot import from outside its
 * own src/, so the clause text is duplicated here. Used by Force Advance,
 * which generates an agreement the same way the app does.
 *
 * app/constants/rentalTerms.ts is the source of truth. Edit the clauses there,
 * bump AGREEMENT_VERSION, then re-run:
 *
 *   node scripts/sync-rental-terms.js
 *
 * If this file drifts from the canonical one, the agreements generated here
 * will disagree with the ones the app shows — and both parties sign those.
 */

export const AGREEMENT_VERSION = 2;

export const TERMS_CLAUSES = [
  {
    title: "Liability for Damages",
    text: "The Renter assumes full responsibility for any damage to the motorcycle caused by their own negligence. In the event of an accident caused by a third party, the matter must be reported to the Police immediately. If the Renter fails to report such an incident and returns the vehicle with damage, the Renter shall be held solely liable for the full cost of repairs.",
  },
  {
    title: "Lawful Use",
    text: "The motorcycle must be operated exclusively by the Renter named in this Agreement. Its use for any illegal activity or in violation of any laws of the Republic of Maldives is strictly prohibited.",
  },
  {
    title: "Unauthorized Riders",
    text: "If the motorcycle is operated by any individual other than the Renter named in this Agreement, the Renter bears full responsibility for any resulting damages. Any insurance coverage applicable to the vehicle will be rendered void in such instances.",
  },
  {
    title: "Compensation for Repair Period",
    text: "If the motorcycle sustains damage while being operated by an unauthorized person, the Renter agrees to compensate the Owner at the daily rental rate for each day the vehicle is out of service for repairs.",
  },
  {
    title: "Helmet Policy",
    text: "If a helmet is provided by the Owner as part of the rental, the Renter is responsible for its safekeeping for the duration of the rental period. In the event of damage or loss attributable to the Renter’s negligence, a replacement fee of MVR 400.00 may be charged by the Owner.",
  },
  {
    title: "Fuel",
    text: "The Renter is responsible for all fuel costs incurred during the rental period. The motorcycle must be returned with at least the same fuel level as at the time of collection.",
  },
  {
    title: "Traffic Regulations",
    text: "The motorcycle must be operated in full compliance with the Land Transport Regulations of the Maldives (Regulation No. 2021/R-131) and all other applicable traffic laws. The Renter is solely responsible for any traffic fines, violations, or penalties incurred during the rental period.",
  },
  {
    title: "Towing and Impoundment",
    text: "If the motorcycle is towed or impounded by the Police or any relevant authority during the rental period, the Renter agrees to pay all tow yard fees and associated fines. Additionally, the Renter agrees to compensate the Owner at the daily rental rate for each day the vehicle remains impounded and out of service.",
  },
  {
    title: "Lost Key",
    text: "In the event the motorcycle key is lost or damaged during the rental period, the Renter shall bear the full cost of obtaining a replacement, which must be procured from the authorised service centre of the motorcycle brand’s distributor.",
  },
  {
    title: "Late Return",
    text: "The motorcycle must be returned at the agreed date and time stated in this Agreement. Late returns will be charged at the hourly late fee rate specified above, rounded up to the next whole hour. The Renter’s in-app booking record reflects the live return deadline including any approved extensions.",
  },
  {
    title: "Right to Repossess",
    text: "The Owner reserves the right to repossess the motorcycle prior to the expiration of the rental period if the Renter violates any of the terms and conditions of this Agreement. In such event, no refund shall be issued for the unused portion of the rental period.",
  },
  {
    title: "Valid Driving Licence",
    text: "The Renter must hold a valid driving licence at all times during the rental period. If the Renter’s licence is suspended, confiscated, or revoked by any authority during the rental period, the Renter must immediately cease operating the motorcycle and notify both the Owner and SaikApp. The Renter assumes full liability for any incidents, damages, fines, or legal consequences arising from operating the motorcycle without a valid licence.",
  },
  {
    title: "Owner’s Warranty",
    text: "The Owner warrants that the motorcycle is in safe, roadworthy condition at the start of the rental period, with current registration, insurance, and all required documentation in place. Any pre-existing damage is recorded in the SaikApp pickup photo record.",
  },
  {
    title: "Payment and Platform",
    text: "Rental fees, extension fees, and any late-return fees are paid directly from the Renter to the Owner by bank transfer, outside the SaikApp platform. SaikApp does not process payments, does not hold or escrow funds at any point, and is not a party to this Agreement or to the payment. SaikApp holds no liability for payment disputes, or for disputes regarding bike condition, damage, or personal injury arising during the rental period.",
  },
  {
    title: "Governing Law",
    text: "This Agreement is governed by the laws of the Republic of Maldives and operates subject to SaikApp’s Terms & Conditions. In the event of a dispute between the Renter and Owner, this Agreement — together with the SaikApp booking record and pickup/return photo documentation — may be presented to relevant authorities as a reference document.",
  },
];

/** The clause fields frozen onto every new `rentalAgreement` snapshot. */
export const frozenTermsFields = () => ({
  clauses: TERMS_CLAUSES,
  agreementVersion: AGREEMENT_VERSION,
});
